module.exports = __webpack_public_path__ + "static/img/20006 (5).7d8902b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20006 (5).webp
// module id = 5CR8
// module chunks = 14